<template>
  <el-dialog
      :visible.sync="visible"
      :title="(sendType==='sell'?'销售开票':'出口发票')+'批量导入'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <div class="table-bar" style="justify-content: flex-start;margin-bottom: 0px">
        <div class="bar-item">
          <UploadButton :url="`/erp/excel/file/read/order-send/${sendType}`" @success="readFileSuccess"></UploadButton>
        </div>
        <FileLink v-if="sendType==='outlet'" file-type="front" file-url="/static/template/出口发票导入模板.xlsx"
                  class="bar-item">下载模板
        </FileLink>
        <FileLink v-if="sendType==='inner'" file-type="front" file-url="/static/template/销售开票导入模板.xlsx"
                  class="bar-item">下载模板
        </FileLink>
        <el-checkbox v-if="sendType==='outlet'" v-model="isAppend">追加导入</el-checkbox>
        <el-checkbox v-if="sendType==='sell'" v-model="checkRepeat">检查重复</el-checkbox>
      </div>
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="500"
                  :summaries-column="['totalAmount','totalCount']" :row-style="rowStyleHandler">
        <el-table-column label="出口发票号" prop="receiptCode" align="center" width="140"
                         :show-tooltip-when-overflow="true" v-if="sendType==='outlet'"></el-table-column>
        <el-table-column label="客户名称" prop="customerName" align="center" width="160"
                         :show-tooltip-when-overflow="true" v-if="sendType==='sell'"></el-table-column>
        <el-table-column label="外销合同号" prop="orderCode" align="center" width="160"
                         :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column label="品番信息"
                         align="center" :show-overflow-tooltip="true">
          <template #default="{row}">
            <ProductRowCard :product="row.product"></ProductRowCard>
          </template>
        </el-table-column>
        <el-table-column label="发货数量" prop="count" width="80"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
            label="发货工厂"
            prop="senderName"
            header-align="center"
            align="center" width="140" :show-overflow-tooltip="true" :formatter="$c.companyNameFormatter">
        </el-table-column>
        <el-table-column label="目的港" prop="receiverName" width="120" v-if="sendType==='outlet'"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="发货日期" width="120" prop="sendDate" align="center">
        </el-table-column>
        <el-table-column label="发货单价" prop="price" width="80"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="税号" prop="taxCode" width="100" v-if="sendType==='sell'"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="银行" prop="bankName" width="100" v-if="sendType==='sell'"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="银行账号" prop="bankAccount" width="100" v-if="sendType==='sell'"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="每箱入数" prop="preBoxCount" width="80" v-if="sendType==='outlet'"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="箱数" prop="boxCount" width="80" v-if="sendType==='outlet'"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="长(cm)" prop="boxLong" width="80" v-if="sendType==='outlet'"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="宽(cm)" prop="boxWidth" width="80" v-if="sendType==='outlet'"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="高(cm)" prop="boxHeight" width="80" v-if="sendType==='outlet'"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="单箱毛重(kg)" prop="weight" width="110" v-if="sendType==='outlet'"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="是否库存" prop="isOldStore" width="80"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
            label="错误提示"
            prop="errorMsg"
            header-align="center" fixed="right"
            align="center" :show-overflow-tooltip="true">
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button size="mini" @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button size="mini" type="primary" @click="doSave" :disabled="!canSubmit">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 供应商成品发货弹窗
 */
import UploadButton from '@/components/UploadButton.vue'
import ProductRowCard from '@/components/ProductRowCard.vue'
import moment from 'moment'
import BigNumber from 'bignumber.js'
import FileLink from '@/components/FileLink.vue'

export default {
  name: 'order-send-import-dialog',
  components: { FileLink, ProductRowCard, UploadButton },
  data () {
    return {
      visible: false,
      dataForm: {},
      isAppend: false,
      checkRepeat:true
    }
  },
  props: {
    sendType: {
      type: String,
      default: 'outlet'
    }
  },
  computed: {
    dataRule () {
      return {}
    },
    canSubmit () {
      if (!this.dataForm || !this.dataForm.detailList) {
        return false
      }
      let hasError = this.dataForm.detailList.every(item => !item.errorMsg)
      return hasError
    }
  },
  methods: {
    rowStyleHandler ({ row, rowIndex }) {
      if (row.errorMsg) {
        return {
          color: 'red'
        }
      }
    },
    readFileSuccess (result) {
      if (result) {
        result.forEach(row => {
          row.totalAmount = new BigNumber(row.totalCount).multipliedBy(row.price).toFixed(3)
        })
      }
      this.dataForm.detailList = result
    },
    init (detailList) {
      this.dataForm = {
        detailList: detailList,
      }
      this.isAppend = false
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    async doSave () {
      let postForm = this.$clone(this.dataForm.detailList)
      postForm.forEach(row => {
        row.productId = row.product.id
        row.isAppend = this.isAppend
        row.checkRepeat=this.checkRepeat
      })
      const loading = this.$loading()
      try {
        const res = await this.$api2.post(`/erp/box/import/box/${this.sendType}`, postForm)
        this.$emit('changed')
        this.visible = false
        this.dataForm.detailList = []
      } finally {
        loading.close()
      }
    }
  },
}
</script>

